import styled from "styled-components/native";
import { space } from "styled-system";
import { Svg } from "react-native-svg";

export const StyledSvg = styled(Svg)`
  ${space}
`;
